import React from "react";
import { gbp, pct } from "@/lib/customerApi";

const Cell = ({ r }) =>
  r ? (
    <span>
      {gbp(r.net_profit)} <span className="text-[#64748B]">· PF {r.profit_factor ?? "-"} · DD {pct(r.max_dd_pct)}</span>
    </span>
  ) : (
    <span className="text-[#64748B]">queued for re-test</span>
  );

export default function StressShowcase({ data }) {
  const rows = data?.showcase || [];
  if (!rows.length) return null;
  return (
    <section data-testid="stress-showcase" className="relative z-10 max-w-[1400px] mx-auto px-6 pb-16">
      <div className="mono text-[11px] uppercase tracking-[0.3em] text-[#22D3EE]">Stress-tested in the open</div>
      <h2 className="text-3xl font-medium tracking-tight mt-2">Bar backtests vs. real ticks.</h2>
      <p className="text-sm text-[#94A3B8] mt-3 max-w-3xl">
        Fast "bar" backtests are optimistic: they guess what happened inside each candle. So we re-run the best bar-tested bots on
        real broker tick data with real spreads. Here are the top 5 bar-tested bots per symbol next to their real-tick result -
        including the ones that fell apart. Only real-tick results are used for the bots we sell.
      </p>
      <div className="mt-6 border border-blue-900/40 rounded-xl overflow-x-auto bg-[#020617]/60">
        <table className="w-full text-xs whitespace-nowrap">
          <thead>
            <tr className="mono text-[10px] uppercase tracking-widest text-[#64748B] border-b border-blue-900/40">
              <th className="text-left px-4 py-3">Symbol</th>
              <th className="text-left px-4 py-3">Bot</th>
              <th className="text-left px-4 py-3">Bar backtest</th>
              <th className="text-left px-4 py-3">Real-tick re-test</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} data-testid={`showcase-row-${i}`} className="border-b border-blue-900/20 hover:bg-blue-950/30 transition-colors">
                <td className="px-4 py-2.5 mono">{r.symbol}</td>
                <td className="px-4 py-2.5 text-[#CBD5E1]">{r.name}</td>
                <td className="px-4 py-2.5"><Cell r={r.bars} /></td>
                <td className="px-4 py-2.5"><Cell r={r.tick} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
